import { render, staticRenderFns } from "./StoryDetail.vue?vue&type=template&id=5f8433cb&scoped=true"
import script from "./StoryDetail.vue?vue&type=script&lang=js"
export * from "./StoryDetail.vue?vue&type=script&lang=js"
import style0 from "./StoryDetail.vue?vue&type=style&index=0&id=5f8433cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8433cb",
  null
  
)

export default component.exports